import SpeciesIcon from '@mui/icons-material/Biotech';
import CategoryIcon from '@mui/icons-material/Category';
import ForestIcon from '@mui/icons-material/Forest';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import type {FC} from 'react';
import {Admin, Resource} from 'react-admin';
import authProvider from '@/admin/authProvider';
import Dashboard from '@/admin/Dashboard';
import dataProvider from '@/admin/dataProvider';
import RedirectLogin from '@/admin/RedirectLogin';
import appraisers from '@/admin/resources/appraisers';
import forestMasses from '@/admin/resources/forestMasses';
import forestMassSpecies from '@/admin/resources/forestMassSpecies';
import inventoryPlots from '@/admin/resources/inventoryPlots';
import inventoryStems from '@/admin/resources/inventoryStems';
import lidarTechnology from '@/admin/resources/lidarTechnology';
import slamPointClouds from '@/admin/resources/slamPointClouds';
import species from '@/admin/resources/species';
import uavPointClouds from '@/admin/resources/uavPointClouds';
import users from '@/admin/resources/users';
import theme from '@/theme/theme';

const _themeOptions = {
  ...theme(),
  palette: {
    secondary: {
      main: '#000000',
    },
  },
};

const AdminApp: FC = () => (
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    theme={_themeOptions}
    requireAuth
    loginPage={RedirectLogin}
    dashboard={Dashboard}
  >
    <Resource name="species" {...species} icon={SpeciesIcon} />
    <Resource name="appraisers" {...appraisers} icon={PeopleIcon} />
    <Resource name="users" {...users} icon={PersonIcon} />
    <Resource name="forest-masses" {...forestMasses} icon={ForestIcon} />
    <Resource name="lidar-technologies" {...lidarTechnology} icon={CategoryIcon} />
    <Resource name="forest-mass-species" {...forestMassSpecies} />
    <Resource name="uav-point-clouds" {...uavPointClouds} />
    <Resource name="slam-point-clouds" {...slamPointClouds} />
    <Resource name="inventory-plots" {...inventoryPlots} />
    <Resource name="inventory-stems" {...inventoryStems} />
  </Admin>
);

export default AdminApp;
